'use strict';

/**
 * View for empty location
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');

var template = require('modules/collection/modules/location/templates/partials/storages-empty.hbs');

var StoragesEmptyView = ItemView.extend({
    template: template,

    className: 'empty-hint',

    viewData: {
        storagesUrl: function() { return '/catalogs/' + this.collection.catalog.id + '/storages'; },
        catalogUrl: function() { return '/catalogs/' + this.collection.catalog.id; },
    },
});

module.exports = StoragesEmptyView;